<template>
  <!-- 一行多选框容器 -->
  <div class="checkbox-row">
    <el-checkbox-group v-model="currentChecked" @change="handleChange">
      <el-checkbox
        v-for="item in options"
        :key="item.categoryId"
        :label="item.categoryId"
        class="checkbox-item"
      >
        <span style="font-size: 12px">
          {{ item.categoryName }}
        </span>
        <!-- 显示分类名称 -->
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "SelectArticle",
  props: {
    // 父组件传入的选项列表（如 ["新闻资讯", "通知公告"]）
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    // 父组件传入的已选中值（双向绑定用）
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 处理 v-model 双向绑定
    currentChecked: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    // 选中状态变化时通知父组件
    handleChange(val) {
      this.$emit("change", val);
      // 可选：如果需要返回完整的选中对象，可额外抛出事件
      const selectedItems = this.options.filter((item) =>
        val.includes(item.id),
      );
      this.$emit("change-items", selectedItems);
    },
  },
};
</script>

<style scoped>
/* 一行多选框的布局样式 */
.checkbox-row {
  width: 100%;
  padding: 3px;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  height: 200px;
}
/* 单个多选框的间距（匹配示例的横向排列） */
.checkbox-item {
  margin-right: 20px; /* 选项之间的间距 */
  margin-bottom: 0 !important; /* 取消 ElementUI 默认的垂直间距 */
}
</style>
